import {
  Engine,
  Scene,
  ArcRotateCamera,
  Vector3,
  Vector4,
  MeshBuilder,
  StandardMaterial,
  Color3,
  Tools,
  Texture,
  HemisphericLight,
  BackgroundMaterial,
} from "@babylonjs/core";
const myScene = {
  engine: null,
  scene: null,
  createScene: function(canvas) {

    const engine = new Engine(canvas);
    const scene = new Scene(engine);
    scene.clearColor = new Color3(0.78, 0.70, 0.59);
    myScene.engine = engine;
    myScene.scene = scene;

    const plankMat = new StandardMaterial("plankMat");
    plankMat.diffuseTexture = new Texture(require('./../../public/img/stoolPlankPictures/01_bohle.jpeg'));
    const frameMat = new StandardMaterial("frameMat");
    frameMat.diffuseColor = new Color3(0.152, 0.16, 0.168);


    /**** Set camera and light *****/
    const position = new Vector3(0, 50, 0)
    const camera = new ArcRotateCamera("camera", Tools.ToRadians(310), Tools.ToRadians(60), 300, position, scene);
    camera.attachControl(canvas, true);
    new HemisphericLight("light", new Vector3(1, 1, 0));


    var groundMat = new BackgroundMaterial("groundMat", scene);
    groundMat.diffuseTexture = new Texture(require('./../../public/texture/concreteTexture.jpg'), scene);
    groundMat.shadowLevel = 0.9;
    const ground = MeshBuilder.CreateGround("ground", {width:600, height:400});
    ground.material = groundMat;

    var faceUV = new Array(6);
    faceUV[0] = new Vector4(0, 0, 1, 1);
    faceUV[1] = new Vector4(0, 0, 1, 1);
    faceUV[2] = new Vector4(0, 0, 1, 1);
    faceUV[3] = new Vector4(0, 0, 1, 1);
    faceUV[4] = new Vector4(0, 0, 1, 1);
    faceUV[5] = new Vector4(0, 0, 1, 1);

    const plank = MeshBuilder.CreateBox("plank", {faceUV: faceUV, wrap: true, updatable: true});
    plank.scaling.x = 40;
    plank.scaling.y = 4;
    plank.scaling.z = 40;
    plank.material = plankMat;
    plank.position.y = 43;

    /**** Legs *****/
    const leg1 = MeshBuilder.CreateBox("leg1", {});
    leg1.scaling.x = 4;
    leg1.scaling.y = 41;
    leg1.scaling.z = 4;
    leg1.position.x = 16.5;
    leg1.position.y = 20.5;
    leg1.position.z = 16.5;
    leg1.material = frameMat;
    const leg2 = MeshBuilder.CreateBox("leg2",{});
    leg2.scaling.x = 4;
    leg2.scaling.y = 41;
    leg2.scaling.z = 4;
    leg2.position.x = - 16.5;
    leg2.position.y = 20.5;
    leg2.position.z = 16.5;
    leg2.material = frameMat;
    const leg3 = MeshBuilder.CreateBox("leg3",{});
    leg3.scaling.x = 4;
    leg3.scaling.y = 41;
    leg3.scaling.z = 4;
    leg3.position.x = - 16.5;
    leg3.position.y = 20.5;
    leg3.position.z = - 16.5;
    leg3.material = frameMat;
    const leg4 = MeshBuilder.CreateBox("leg4",{});
    leg4.scaling.x = 4;
    leg4.scaling.y = 41;
    leg4.scaling.z = 4;
    leg4.position.x = 16.5;
    leg4.position.y = 20.5;
    leg4.position.z = - 16.5;
    leg4.material = frameMat;
    /**** Top Frame *****/
    const frameTop1 = MeshBuilder.CreateBox("frameTop1",{});
    frameTop1.scaling.x = 4;
    frameTop1.scaling.y = 4;
    frameTop1.scaling.z = 35;
    frameTop1.position.x = 16.5;
    frameTop1.position.y = 39;
    frameTop1.position.z = 0;
    frameTop1.material = frameMat;
    const frameTop2 = MeshBuilder.CreateBox("frameTop2",{});
    frameTop2.scaling.x = 35;
    frameTop2.scaling.y = 4;
    frameTop2.scaling.z = 4;
    frameTop2.position.x = 0;
    frameTop2.position.y = 39;
    frameTop2.position.z = 16.5;
    frameTop2.material = frameMat;
    const frameTop3 = MeshBuilder.CreateBox("frameTop3",{});
    frameTop3.scaling.x = 4;
    frameTop3.scaling.y = 4;
    frameTop3.scaling.z = 35;
    frameTop3.position.x = - 16.5;
    frameTop3.position.y = 39;
    frameTop3.position.z = 0;
    frameTop3.material = frameMat;
    const frameTop4 = MeshBuilder.CreateBox("frameTop4",{});
    frameTop4.scaling.x = 35;
    frameTop4.scaling.y = 4;
    frameTop4.scaling.z = 4;
    frameTop4.position.x = 0;
    frameTop4.position.y = 39;
    frameTop4.position.z = - 16.5;
    frameTop4.material = frameMat;

    // let buffer = box.getVerticesData(BABYLON.VertexBuffer.UVKind);
    // plank.updateVerticesData(BABYLON.VertexBuffer.UVKind, buffer);

    engine.runRenderLoop(() => {
      scene.render();
    });

    window.addEventListener("resize", function () {
            engine.resize();
    });

  },

  setHeight: function(legHeight, legYposition, frameTopYposition) {
    this.scene.getMeshByName("leg1").position.y = legYposition
    this.scene.getMeshByName("leg2").position.y = legYposition
    this.scene.getMeshByName("leg3").position.y = legYposition
    this.scene.getMeshByName("leg4").position.y = legYposition
    this.scene.getMeshByName("plank").position.y = legHeight + 2
    this.scene.getMeshByName("leg1").scaling.y = legHeight
    this.scene.getMeshByName("leg2").scaling.y = legHeight
    this.scene.getMeshByName("leg3").scaling.y = legHeight
    this.scene.getMeshByName("leg4").scaling.y = legHeight
    this.scene.getMeshByName("frameTop1").position.y = frameTopYposition
    this.scene.getMeshByName("frameTop3").position.y = frameTopYposition
    this.scene.getMeshByName("frameTop2").position.y = frameTopYposition
    this.scene.getMeshByName("frameTop4").position.y = frameTopYposition
  },
  setFrameType: function(getLegsDepth, legZposition) {
    this.scene.getMeshByName("leg1").scaling.z = getLegsDepth
    this.scene.getMeshByName("leg2").scaling.z = getLegsDepth
    this.scene.getMeshByName("leg3").scaling.z = getLegsDepth
    this.scene.getMeshByName("leg4").scaling.z = getLegsDepth
    this.scene.getMeshByName("leg1").position.z = legZposition
    this.scene.getMeshByName("leg2").position.z = legZposition
    this.scene.getMeshByName("leg3").position.z = - legZposition
    this.scene.getMeshByName("leg4").position.z = - legZposition
  },
  setPlank: function(plankName){
    this.scene.getMaterialByName("plankMat").diffuseTexture = new Texture(require('./../../public/img/stoolPlankPictures/' + plankName));
  },
  setColor: function(r, g, b){
    this.scene.getMaterialByName("frameMat").diffuseColor = new Color3(r, g, b)
  }
};
export default myScene;
